import { useState } from 'react';
import {
  AuthPanel,
  MfaCodeForm,
  MfaCodeFormValues,
} from '@nbirl/nbi-common-ui-libs';
import { FormikHelpers } from 'formik';

import { useAuth } from '../../../shared/context';
import { useErrorToast } from '../../../shared/hooks';

export const MfaCode = ({
  mfaType,
}: {
  mfaType: 'SOFTWARE_TOKEN_MFA' | 'SMS_MFA';
}) => {
  const { confirmSignIn, signOut } = useAuth();
  const [isPending, setIsPending] = useState(false);
  const { showErrorToast } = useErrorToast();

  const helpText =
    mfaType === 'SOFTWARE_TOKEN_MFA'
      ? 'Open your authentication app and enter the security code it provides.'
      : 'We have delivered the authentication code by SMS. Please enter the code to complete authentication.';

  const handleSubmit = async (
    { code }: MfaCodeFormValues,
    formikHelpers: FormikHelpers<MfaCodeFormValues>
  ) => {
    try {
      setIsPending(true);
      await confirmSignIn(mfaType, code);
    } catch (error: any) {
      setIsPending(false);

      if (error?.code === 'CodeMismatchException') {
        formikHelpers.setFieldError('code', 'Invalid authentication code');
      } else {
        showErrorToast(error);
      }
    }
  };

  return (
    <AuthPanel>
      <MfaCodeForm
        helpText={helpText}
        isPending={isPending}
        onSubmit={handleSubmit}
        onBack={() => signOut()}
      />
    </AuthPanel>
  );
};
